<template>
  <select name="" id="" class="form-control" v-model="data.status" @change="changeStatus">
    <option v-for="(item, key) in statusList" :key="key" :value="item.value">{{item.key}}</option>
  </select>
</template>

<script>
import { useStore } from "@/store";
import api from "@/api/index";
 import { GeneralActionTypes } from "@/store/modules/general/action-types";
import Swal from "sweetalert2";
import { store } from '../../../store';
export default {
  name: "tableStatusChanger",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  setup () {
    const store = useStore();

    if (!store.state.general.reviewStatuses.length) {
      store.dispatch(GeneralActionTypes.GET_REVIEW_STATUSES, null);
    }

    const statusList = store.state.general.reviewStatuses;

    return {statusList}
  },
  methods: {
    async changeStatus() {
      Swal.fire({
        title: "Are You Sure?",
        icon: "warning",
        text: "You are about to update the selected item!",
        showCancelButton: true,
        confirmButtonText: "Save",
        cancelButtonText: "Close",
      }).then(async(result) => {
        if (result.isConfirmed) {
          let body = {
            id: this.data.id,
            status: this.data.status,
          };

          const res = await api.policyReview.changeReviewStatus(body);
          
          if (res) {
            window.location.reload()
          }
        }
      });
    }
  },
}
</script>

<style scoped>

</style>